// extracted by mini-css-extract-plugin
module.exports = {"namesContainer":"PartnerContactForm_namesContainer__drOZQ"};